/** Versión del shell de navegación lateral + header del dashboard. */
export enum MenuVersionEnum {
  V1 = 'v1',
  V2 = 'v2',
}

/** Versión por defecto (VDS-3070: menú segmentado). */
export const DEFAULT_MENU_VERSION = MenuVersionEnum.V2;

const MENU_VERSION_VALUES = new Set<string>(Object.values(MenuVersionEnum));

export function isMenuVersion(value: unknown): value is MenuVersionEnum {
  return typeof value === 'string' && MENU_VERSION_VALUES.has(value);
}

/** Normaliza el valor de `whiteLabel.projects.dashboard.menu.version` desde API/config. */
export function parseMenuVersion(raw: string | undefined): MenuVersionEnum {
  if (isMenuVersion(raw)) {
    return raw;
  }
  return DEFAULT_MENU_VERSION;
}
